module.exports = __webpack_public_path__ + "img/circle.5feee4fd.svg";